import React from "react";
import ContractDashboard, { fromWei } from "./shared/ContractDashboard";
import burnRewardFunctions from "./functions/burnRewardFunctions";
import { oxyBurnReward, oxyBurnRewardAbi } from "./Contract";

const short = (v) => `${String(v).slice(0, 8)}…${String(v).slice(-6)}`;

/**
 * Oxy Burn Reward — signature-gated trade burning and the reward pools that fund it.
 * Every function of the oxyBurnReward contract is available through the tabs below.
 */
export default function NftBurnReward() {
  const overview = [
    {
      key: "globalMarketPlaceReward",
      label: "Marketplace Reward Pool",
      icon: "🛒",
      method: "globalMarketPlaceReward",
      format: (v) => `${fromWei(v)} USDT`,
      color: "#ff8800",
    },
    {
      key: "globalMatrixReward",
      label: "Matrix Reward Pool",
      icon: "🧬",
      method: "globalMatrixReward",
      format: (v) => `${fromWei(v)} USDT`,
      color: "#00ff88",
    },
    {
      key: "contractUsdt",
      label: "Contract USDT",
      icon: "🏦",
      color: "#26a17b",
      format: (v) => `${v} USDT`,
      compute: async ({ getTokenContract, address }) =>
        fromWei(await getTokenContract("USDT").methods.balanceOf(address).call()),
    },
    {
      key: "burnTradeSigner",
      label: "Burn Trade Signer",
      icon: "✍️",
      method: "burnTradeSigner",
      format: short,
      color: "#ff00aa",
    },
    {
      key: "nftMarketPlace",
      label: "Linked Marketplace",
      icon: "🎨",
      method: "nftMarketPlace",
      format: short,
      color: "#45b7d1",
    },
    {
      key: "nftMatrix",
      label: "Linked Matrix",
      icon: "🌳",
      method: "nftMatrix",
      format: short,
      color: "#6be0d7",
    },
    {
      key: "usdtToken",
      label: "USDT Token",
      icon: "💵",
      method: "usdtToken",
      format: short,
      color: "#00ccff",
    },
    {
      key: "paused",
      label: "Contract Status",
      icon: "⚡",
      method: "paused",
      format: (v) => (v === true || v === "true" ? "PAUSED" : "ACTIVE"),
      color: "#ff6b6b",
    },
  ];

  return (
    <ContractDashboard
      title="Oxy Burn Reward"
      subtitle="Signature-gated trade burning and the reward pools that fund it"
      icon="🔥"
      accent="#ff8800"
      address={oxyBurnReward}
      abi={oxyBurnRewardAbi}
      functions={burnRewardFunctions}
      overview={overview}
      approvalTokens={["USDT"]}
    />
  );
}
